define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.WaTypeAccess = void 0;
    class WaTypeAccess extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "WaId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WaIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WfRegulationMethod", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WfRegulationMethodError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WfMinVolume", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WfMinVolumeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WfFractionRemaining", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WfFractionRemainingError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WfStorageType", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WfStorageTypeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Wa", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, WaTypeAccess.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.Wa = parent;
            this.WaId = parent.Id;
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
        }
        onRead(entity, parent) {
            this.Wa = parent;
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.WaId = (0, EntityUtil_1.toInt)(entity.WaId);
            a.WfRegulationMethod = (0, EntityUtil_1.toInt)(entity.WfRegulationMethod);
            a.WfMinVolume = (0, EntityUtil_1.toInt)(entity.WfMinVolume);
            a.WfFractionRemaining = (0, EntityUtil_1.toInt)(entity.WfFractionRemaining);
            a.WfStorageType = (0, EntityUtil_1.toInt)(entity.WfStorageType);
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
        }
        onReady() {
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, WaTypeAccess.AliasName);
            this.reset();
            this._validate(validationState, recurseChildren);
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                this.validateReqNumber(validationState, "WaId", "Water Agreement ID");
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                WaId: this.WaId,
                WfRegulationMethod: this.WfRegulationMethod,
                WfMinVolume: this.WfMinVolume,
                WfFractionRemaining: this.WfFractionRemaining,
                WfStorageType: this.WfStorageType,
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
    }
    exports.WaTypeAccess = WaTypeAccess;
    Object.defineProperty(WaTypeAccess, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "WaTypeAccess"
    });
    Object.defineProperty(WaTypeAccess, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Landowner Access Agreement"
    });
    Object.defineProperty(WaTypeAccess, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "WaId", "WfRegulationMethod", "WfMinVolume", "WfFractionRemaining", "WfStorageType"]
    });
    Object.defineProperty(WaTypeAccess, "WaIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaTypeAccess, "WfRegulationMethodTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "How will the water use be regulated?"
    });
    Object.defineProperty(WaTypeAccess, "WfRegulationMethodDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaTypeAccess, "WfRegulationMethodReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaTypeAccess, "WfMinVolumeTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "What is the minimum volume (in litres) of water required for the Landowner’s stock?"
    });
    Object.defineProperty(WaTypeAccess, "WfMinVolumeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaTypeAccess, "WfFractionRemainingTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "What fraction of the Water Facility’s water storage must always remain available?"
    });
    Object.defineProperty(WaTypeAccess, "WfFractionRemainingDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaTypeAccess, "WfFractionRemainingReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaTypeAccess, "WfStorageTypeTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "What type of storage does the Water Facility have?"
    });
    Object.defineProperty(WaTypeAccess, "WfStorageTypeDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaTypeAccess, "WfStorageTypeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeAccess.prototype, "WaId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeAccess.prototype, "WaIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeAccess.prototype, "WfRegulationMethod", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeAccess.prototype, "WfRegulationMethodError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeAccess.prototype, "WfMinVolume", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeAccess.prototype, "WfMinVolumeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeAccess.prototype, "WfFractionRemaining", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeAccess.prototype, "WfFractionRemainingError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeAccess.prototype, "WfStorageType", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeAccess.prototype, "WfStorageTypeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaTypeAccess.prototype, "Wa", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], WaTypeAccess.prototype, "onCreate", null);
    tslib_1.__decorate([
        mobx_1.action
    ], WaTypeAccess.prototype, "onRead", null);
    tslib_1.__decorate([
        mobx_1.action
    ], WaTypeAccess.prototype, "merge", null);
});
